<template>
  <div class="tabs">
    <div class="item" :class="{ active: activeId == 1}" @click="change(1)">
      {{ $t("login.account_password_login") }}
    </div>
    <div class="item" :class="{ active: activeId == 2 }" @click="change(2)">
      {{ $t("login.message_login_text") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeId: {
      type: [String, Number],
      default: 1
    }
  },
  methods: {
    change(id){
      this.$emit("change", id);
    }
  }
}
</script>

<style scoped lang="less">
  .tabs{
    margin-top: 40px;
    display: flex;
    .item{
      &:nth-child(1){
        margin-left: 0;
      }
      margin-left: 50px;
      font-size: 32px;
      color: #888;
      line-height: 80px;
      position: relative;
      font-weight: bold;
      &:after{
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 4px;
        background: #1c0955;
        transition: all .2s;
      }
      &.active{
        color: #1c0955;
        &:after{
          width: 80px;
        }
      }
    }
  }
</style>
